import React, {FC, ReactElement, useCallback, useEffect, useState} from "react";
import LoaderWithCompanySelected from "../../../components/LoaderWithCompanySelected";
import {Alert, CircularProgress, Grid, TextField} from "@mui/material";
import {purchaseInvoiceRecognitionApi} from "../../../backend/PurchaseInvoiceRecognitionApi";
import {ResultOrErrorDto} from "../../../model/ResultOrErrorDto";
import {RecognisePurchaseInvoiceResponse} from "../../../model/invoice/purchase/FetchPurchaseInvoicesForReviewResponse";

interface IProps {
    file: File,
    taskId: string,
}

export const RecogniseSinglePurchaseInvoice: FC<IProps> = ({file, taskId}): ReactElement => {
    const [result, setResult] = useState<ResultOrErrorDto<RecognisePurchaseInvoiceResponse>>()

    const doRefreshStatus = useCallback(async () => {
        const status = await purchaseInvoiceRecognitionApi.fetchStatus(taskId)
        if (status === "ERROR" || status === "FINISHED") {
            const result = await purchaseInvoiceRecognitionApi.fetchResult(taskId);
            setResult(result);
        }
    }, []);

    useEffect(() => {
        if (result == null) {
            const timer = setInterval(doRefreshStatus, 5000);
            return () => clearInterval(timer)
        }
    }, [result])

    return <LoaderWithCompanySelected loading={false}>
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={2}>
                {file.name}
            </Grid>
            {result == null && <Grid item xs={2}>
                <CircularProgress size="1.2rem"/>
            </Grid>}
            {result && result.error == null && <>
                <Grid item xs={2}>
                    <Alert severity="success">Uploaded</Alert>
                </Grid>
                <Grid item xs={6}>
                    <TextField
                            label="Debug info"
                            value={result.result!!.rawAnswer}
                            multiline
                            fullWidth
                            minRows={1}
                            maxRows={12}
                    />
                </Grid>
            </>}
            {result && result.error != null && <>
                <Grid item xs={2}>
                    <Alert severity="error">Failed to upload invoice</Alert>
                </Grid>
                <Grid item xs={6}>
                    <TextField
                            label="Debug info"
                            value={result.error}
                            multiline
                            fullWidth
                            minRows={1}
                            maxRows={5}
                    />
                </Grid>
            </>}
        </Grid>
    </LoaderWithCompanySelected>
}